import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { CourseAdminCard } from '@/components/shared/CourseAdminCard';
import {
  CardDragglableProps,
  CardStaticProps,
} from '@/components/shared/CourseAdminCard/types';
import { Toggle } from '@/components/ui/daisy';
import LimitedEditionWrapper from '../shared/LimitedEditionWrapper';

type ExamAreaCardProps = {
  name: string;
  isAttached?: boolean;
  onToggle: () => void;
  isPending?: boolean;
  ordinal?: number;
  className?: string;
  isLimitedEdition?: boolean;
} & (CardStaticProps | CardDragglableProps);

export default function ExamAreaCard({
  name,
  isAttached,
  onToggle,
  isPending,
  ordinal,
  isLimitedEdition = false,
  ...cardProps
}: ExamAreaCardProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.examWorkspace.settings',
  });

  return (
    <CourseAdminCard {...cardProps}>
      <CourseAdminCard.Header className={twMerge(!isAttached && 'opacity-60')}>
        <CourseAdminCard.Leading>
          <CourseAdminCard.Order value={ordinal} />
          <CourseAdminCard.Title className="font-medium">
            {name}
          </CourseAdminCard.Title>
        </CourseAdminCard.Leading>
        <CourseAdminCard.Actions className="gap-2">
          <span className="text-sm text-base-content">{t('showLabel')}</span>
          <LimitedEditionWrapper
            isLimitedEdition={isLimitedEdition}
            placement="left"
          >
            <Toggle
              color="primary"
              checked={!!isAttached}
              onChange={() => onToggle()}
              disabled={isPending || isLimitedEdition}
            />
          </LimitedEditionWrapper>
        </CourseAdminCard.Actions>
      </CourseAdminCard.Header>
    </CourseAdminCard>
  );
}
